import { cn } from '@/lib/utils';

interface ConicGradientBorderProps {
  children: React.ReactNode;
  size?: number;
  borderWidth?: number;
  className?: string;
}

/**
 * Circular border component using profile_border.png for a conic gradient effect.
 * Matches the mobile app's ConicGradientBorder widget.
 */
export function ConicGradientBorder({
  children,
  size = 58,
  borderWidth = 4,
  className,
}: ConicGradientBorderProps) {
  const innerSize = size - borderWidth * 2;

  return (
    <div
      className={cn('relative flex items-center justify-center', className)}
      style={{
        width: size,
        height: size,
        backgroundImage: 'url(/profile_border.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: '50%',
      }}
    >
      <div
        className="rounded-full overflow-hidden"
        style={{
          width: innerSize,
          height: innerSize,
        }}
      >
        {children}
      </div>
    </div>
  );
}
